
import XButton from 'vux/src/components/x-button/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import Confirm from 'vux/src/components/confirm/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'

import { mapState } from "vuex";
import utils from "../../utils";
export default {
name: "myHeader",
components: {
Flexbox,
FlexboxItem,
XButton,
Confirm,
XHeader
},
directives: {
TransferDom
},
props: {
op88888: {
type: Boolean,
default: false
}
},
watch: {



},
data() {
return {
isIE: utils.isIE(),
showLang: false,
language: "zh-CN",
options: [],
value: ""

};
},
mounted() {
this.language = this.$locale.get();

},
computed: {
...mapState({
rotateIcon: state => state.app.rotateVal
})
},
methods: {
showLangList() {
this.showLang = !this.showLang;
},
handleClickMenu() {
this.$store.dispatch("setRotate", true);
this.$emit("menuClick");
},
handleChangeLanguage(language) {
this.language = language;
this.$i18n.set(this.language);
this.$store.dispatch("setLang", this.language);
this.$locale.set(this.language);
this.showLang = false;
}
}
};



// WEBPACK FOOTER //
// ./src/components/myHeader/index.vue